export const isInchesUnit = unit => /^in/i.test(unit);

export const isMetersUnit = unit => /^m/i.test(unit);

export const SEQUENCE_HEIGHT_LIMITS = {
  min: {
    feet: 1,
    inches: 0,
    total: 12
  },
  max: {
    feet: 9,
    inches: 12,
    total: 119
  }
};
